<div class="content-container">
    <div class="overlay-container standalone-player">
    </div>
</div>